import HomePage from './pages/HomePage'
import BooksPage from './pages/BooksPage'
import OrderPage from './pages/OrderPage'
import SampleBookPage from './pages/SampleBookPage'
import StudioPage from './pages/StudioPage'

export default function App() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/'
  if (path === '/studio') return <StudioPage />
  if (path === '/books') return <BooksPage />
  if (path === '/order') return <OrderPage />
  if (path === '/sample') return <SampleBookPage />
  return <HomePage />
}
